import { PYUseQueryOptions } from "../../hooks/StandardQueryArguments";

import { IReviewFormData, getReviewForms } from "../../services/defs/forms";

export type ReviewFormsQueryParams = {
	searchTerm?: string;
	includeDeleted?: boolean;
	includeUsed?: boolean;
};

export const reviewFormsQuery = (
	{ searchTerm, includeDeleted = false, includeUsed = false }: ReviewFormsQueryParams,
	options?: PYUseQueryOptions<IReviewFormData>
) => ({
	queryKey: ["review-forms", searchTerm, includeDeleted, includeUsed],
	queryFn: () => getReviewForms(searchTerm, includeDeleted, includeUsed),
	meta: {
		errorMessage: "There was an error getting the review forms.",
	},
	...options,
});
